const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.96 17.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.8,.04L.26,2.94c-.16,.07-.26,.23-.26,.4V7.71c0,4.26,2.92,8.25,6.86,9.28,.08,.02,.17,.02,.25,0,3.94-1.03,6.86-5.02,6.86-9.28V3.35c0-.17-.1-.33-.26-.4L7.16,.04c-.11-.05-.24-.05-.36,0Zm.18,8.44h4.91c.27,0,.49,.25,.44,.52-.52,2.76-2.32,5.19-4.75,6.2-.28,.12-.59-.11-.59-.42v-6.3H1.99c-.24,0-.44-.2-.44-.44v-3.69c0-.17,.1-.33,.26-.4L6.36,1.93c.29-.13,.62,.08,.62,.4v6.15Z",
    style: {
      fill: "#ccc"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/security-icon.7052838e6b725c52c4141c4bc8ddb65d.svg";
export { ForwardRef as ReactComponent };